import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isApiKeysEnabled } from '~/constants/featureFlag'
import { ApiKeyCreate } from '~/pages/ApiKeys/create'

export type ApiKeyCreateSearch = {
  source?: string
}

const ApiKeyCreatePage: React.FC = () => {
  const { source } = Route.useSearch()
  return (
    <OrganizationAdmin thorwError>
      <ApiKeyCreate sourceApiKeyId={source} />
    </OrganizationAdmin>
  )
}

export const Route = createFileRoute('/_authenticated/api_keys/create')({
  // 開発中のAPIキー機能が無効な環境ではページにアクセスさせずホームへリダイレクトする
  beforeLoad: () => {
    if (!isApiKeysEnabled) {
      // redirect() は throw して使うのが TanStack Router の作法
      throw redirect({ to: '/' })
    }
  },
  validateSearch: (search: Record<string, unknown>): ApiKeyCreateSearch => ({
    source:
      typeof search.source === 'string' && search.source !== ''
        ? search.source
        : undefined,
  }),
  component: ApiKeyCreatePage,
})
